import { ComponentProps, CSSProperties, JSX } from 'react';

import { Image, ImageProps } from 'next-bricks';

import { cn } from 'utils/cn';

import styles from './styles.module.css';

type OverlayType = 'image' | 'shadow';

interface Overlay {
	type: OverlayType;
	image?: {
		src: ImageProps['src'];
		priority?: ImageProps['priority'];
	};
	shadow?: {
		opacity?: number;
		color?: string;
	};
}

interface SectionProps extends ComponentProps<'section'> {
	height?: CSSProperties['height'];
	paddingVertical?: CSSProperties['paddingTop'];

	overlays?: Overlay[];

	containerClassName?: string;
	containerChildren?: React.ReactNode | JSX.Element;
	children?: React.ReactNode | JSX.Element;
}

function Section({
	height,
	paddingVertical,
	overlays = [],
	containerClassName,
	containerChildren,
	className,
	children,
	...props
}: SectionProps) {
	return (
		<section
			className={cn(styles.container, containerClassName)}
			style={{
				height: height ?? 'auto',

				paddingTop: paddingVertical ?? '4rem',
				paddingBottom: paddingVertical ?? '4rem',
			}}
			{...props}
		>
			<div className={styles.overlays}>
				{overlays.map((overlay, index) => (
					<div key={index}>
						{overlay.type === 'image' && (
							<div className={styles.image}>
								<Image
									src={overlay.image?.src ?? ''}
									alt={`Background da seção`}
									priority={overlay.image?.priority ?? false}
								/>
							</div>
						)}

						{overlay.type === 'shadow' && (
							<div
								className={styles.shadow}
								style={{
									background: overlay.shadow?.color,
									opacity: overlay.shadow?.opacity,
								}}
							/>
						)}
					</div>
				))}
			</div>

			<div className={cn('content', styles.content, className)}>
				{children}
			</div>

			{containerChildren}
		</section>
	);
}

export default Section;
